export const USE_SEMANTIC_COLORS = true;

export const tokens = {
  // Mantemos status existentes (não alterar nesta tarefa)
  status: {
    AGUARDANDO: { fg: 'text-blue-400', bgSoft: 'bg-blue-400/10' },
    PAGO: { fg: 'text-emerald-400', bgSoft: 'bg-emerald-400/10' },
    CANCELADO: { fg: 'text-red-400', bgSoft: 'bg-red-400/10' },
    PARCIAL: { fg: 'text-orange-400', bgSoft: 'bg-orange-400/10' },
    OUTRO: { fg: 'text-gray-400', bgSoft: 'bg-gray-400/10' },
    LIBERADO: { fg: 'text-green-400', bgSoft: 'bg-green-400/10' },
    'ARTE FINAL': { fg: 'text-purple-400', bgSoft: 'bg-purple-400/10' },
    'SEPARAÇÃO': { fg: 'text-blue-400', bgSoft: 'bg-blue-400/10' },
    'IMPRESSÃO': { fg: 'text-cyan-400', bgSoft: 'bg-cyan-400/10' },
    'PRENSAGEM': { fg: 'text-yellow-400', bgSoft: 'bg-yellow-400/10' },
    'CONTROLE DE QUALIDADE': { fg: 'text-indigo-400', bgSoft: 'bg-indigo-400/10' },
    'EXPEDIÇÃO': { fg: 'text-lime-400', bgSoft: 'bg-lime-400/10' },
    'DISPONIVEL PARA COLETA': { fg: 'text-green-400', bgSoft: 'bg-green-400/10' },
  },
  // Serviços (materiais)
  service: {
    'DTF TÊXTIL': 'bg-blue-600',
    'DTF UV (VERNIZ)': 'bg-violet-600',
    'DTF UV (FOSCO)': 'bg-violet-400',
    'SUBLIMAÇÃO (COM TACK)': 'bg-teal-600',
    'SUBLIMAÇÃO (SEM TACK)': 'bg-emerald-300',
    'ADESIVO UV (VERNIZ)': 'bg-orange-600',
    'ADESIVO UV (FOSCO)': 'bg-orange-300',
    'NEUTRO': 'bg-gray-400',
  },
  // Qualidades
  quality: {
    // DTF TÊXTIL
    PREMIUM: 'bg-blue-600',
    CLASSICO: 'bg-gray-600',
    SOFT: 'bg-fuchsia-400',
    ECONOMICO: 'bg-rose-400',

    // Legados/compatibilidade (UV/Adesivo/Sublimação)
    'FOSCO': 'bg-violet-400',
    'BRILHO': 'bg-violet-600',
    'COM TACK': 'bg-teal-600',
    'SEM TACK': 'bg-emerald-300'
  },
  // Medidas
  measure: {
    METRO: 'bg-lime-400',
    UNIDADE: 'bg-yellow-300',
    PEDIDO_MINIMO: 'bg-red-700'
  }
} as const;

// Aliases de serviço para entradas antigas
export const serviceAlias: Record<string, keyof typeof tokens.service> = {
  'DTF UV': 'DTF UV (VERNIZ)',
  'SUBLIMAÇÃO': 'SUBLIMAÇÃO (COM TACK)',
  'ADESIVO UV': 'ADESIVO UV (VERNIZ)',
  'DTF UV FOSCO': 'DTF UV (FOSCO)',
  'SUBLIMACAO': 'SUBLIMAÇÃO (COM TACK)',
  'SUBLIMACAO COM TACK': 'SUBLIMAÇÃO (COM TACK)',
  'SUBLIMACAO SEM TACK': 'SUBLIMAÇÃO (SEM TACK)',
  // Aliases adicionais: impressão DTF Têxtil (metro)
  'IMPRESSAO DTF TEXTIL ( METRO )': 'DTF TÊXTIL',
  'IMPRESSAO DTF TEXTIL (METRO)': 'DTF TÊXTIL',
  'DTF TEXTIL ( METRO )': 'DTF TÊXTIL',
  'DTF TEXTIL (METRO)': 'DTF TÊXTIL'
};


